// extracted by mini-css-extract-plugin
export default {"comment-banner":"styles__comment-banner___RFoG_","comment-banner-content":"styles__comment-banner-content___TJ5FX"};